import { IData } from '../fetchPaymentDictionary'
import { IPaymentDictionary } from '../index'

export default function(response: IData) {
  return response.items.map(
    (item): IPaymentDictionary => ({
      id: Number(item.id),
      idUser: Number(item.id_user),
      isDeleted: Boolean(Number(item.deleted)),
      name: item.name,
    }),
  )
}
